<template>
  <div class="popUpMain">
    <div class="popUpTop">

      <div class="popUpCol">
        <Input placeholder="ROT No" :inputValue.sync="data['RotNo']" :isDisabled="data['mode'] == 'V'"/>
        <div class="rowItems">
          <Input placeholder="Job No" :inputValue.sync="data['JobNo']" :isRequired="true" :isDisabled="true" :errorMessage.sync="data['rotErrors']['jobno']"/>
          <Input placeholder="Job Type" :inputValue.sync="data['JobType']" :isDisabled="true"/>
        </div>
        <div class="rowItems">
          <DateTimePicker placeholder="ROT Date/Time" :value.sync="data['ROTDate']" :isDisabled="data['mode'] == 'V'"/>
          <CheckBox :isChecked.sync="data['Urgent']" title="Urgent" @checkBoxClicked="null" :isDisabled="true"/>
        </div>
        <Input placeholder="Customer Code" :inputValue.sync="data['CustCode']" :isDisabled="true"/>
        <Input placeholder="Customer Name" :inputValue.sync="data['CustName']" :isDisabled="true"/>
        <InputQuery placeholder="Haul Bill To" :isRequired="true" :items="data['rotHaulBillTo']" itemKey="BillTo" descKey=""
          :selectedObject.sync="data['HallBillTo']" :isDisabled="data['mode'] == 'V'" :errorMessage.sync="data['rotErrors']['haulbillto']"/>
      </div>

      <div class="popUpCol">
        <InputQuery placeholder="Haulier" :isRequired="true" :items="data['rotHaulier']" itemKey="Haulier Code" descKey="Description"
          :selectedObject.sync="data['Haulier']" :isDisabled="data['mode'] == 'V'" :errorMessage.sync="data['rotErrors']['haulier']"/>
        <Input placeholder="Haul Rqt No" :inputValue.sync="data['HaulRqtNo']" :isDisabled="true"/>
        <Input placeholder="Haul Accept Time" :inputValue.sync="data['HaulAcceptTime']" :isDisabled="true"/>
        <InputQuery placeholder="Requested By" :isRequired="true" :items="data['rotEmployee']" itemKey="Employee ID" descKey="Employee Name"
          :selectedObject.sync="data['RqtBy']" :isDisabled="data['mode'] == 'V'" :errorMessage.sync="data['rotErrors']['rqtby']"/>
        <Input placeholder="Rqt Accepted By" :inputValue.sync="data['RqtAcceptBy']" :isDisabled="data['mode'] == 'V'"/>
      </div>

      <div class="popUpTopCtrlMain">
        <div class="indMain"> {{data['Ind']}} </div>

        <div class="printCMain" @click="quickPrintBtn('quickPrintShow', true)">
          <img class="printCImg" src="https://img.icons8.com/android/24/000000/print.png"/>
          <div class="printCValue"> CMR: {{data['PrintCount']}} </div>
        </div>
      </div>
    </div>
    <div class="popUpBottom">
      <TabView class="tabsMain" :tabs="tabsItem" :activeTab.sync="data['tabsActive']"/>
    </div>

    <Loader :isVisible="loadShow" :loadingText="loadText"/>
  </div>
</template>

<script>
/* eslint-disable */
import Tabulator from '@/components/Tabulator.vue';
import TabView from '@/components/TabView.vue';
import Input from '@/components/Input.vue';
import Dropdown from '@/components/Dropdown.vue';
import Loader from '@/components/Loader.vue';
import CheckBox from '@/components/CheckBox.vue';

export default {
  components: {
    Tabulator, Input, Dropdown, TabView, Loader, CheckBox
  },
  data: function() {
    return {
    }
  },
  props: {
    //-------- Main Props
    data: { type: Object, default: function () { return {} } },
    viewMode: { type: Boolean, default: false },

    //-------- TabView Props
    tabsItem: { type: Array, default: function() { return [
      { title: 'Location Info', component: 'LocationInfo', data: this.data, enabled: true },
      { title: 'Container Info', component: 'ContainerInfo', data: this.data, enabled: true },
      { title: 'Attachments', component: 'AttachmentsPage', data: this.data, enabled: true },
    ]; }},
    
    //-------- Load Props
    loadShow: { type: Boolean, default: false },
    loadText: { type: String, default: 'Loading' },
  },
  mounted() {    
    this.$set(this.data, 'rotContROTView', []);
    this.$bus.$on('ROTJobsLoadData', this.getData);
  },
  methods: {
    test: async function(fnc) {
      switch (fnc) {
        case 'E':
          console.log(this.data);
          break;
        case 'EE':
          //-------- SentTo
          try {
            // this.loadText = 'Getting Send To Destinations'; 
            var rotJobDetail = await this.$apiCallV2('/ROT/GetRotJob?compname=pc1&startdate=2020-01-01&enddate=2021-01-01');
            console.log(rotJobDetail);
            // var rotJobDetailF = [];
            // if (Array.isArray(rotJobDetail['data'])) { rotJobDetail['data'].forEach((s) => { rotJobDetailF.push(s); }); }
            // this.$set(this.data, 'rotJobDetail', rotJobDetailF);
            // this.$set(this.data, 'rotJobDetailRaw', rotJobDetail['data']);
          } catch (e) { console.log(e); }
          break;
        case 'EEE':
          console.log(this.data);
          break;
      }
    },
    getData: async function() {
      this.loadShow = true;
      
      //-------- ROT Details
      if (this.data['mode'] != 'N') {
        try {
          this.$set(this.data, 'rotDetails', null);
          this.loadText = 'Getting ROT Details'; 
          var rotDetails = await this.$apiCallV2('/ROT/GetROTDetails?cmrno=' + this.data['rotSelect']['ROT #'] + '&jobno=');
          //console.log('%cROT Details', 'color: lightpink;', rotDetails['data']['ROTDetails']['CMRForm']);
          if (typeof rotDetails == 'object') { this.$set(this.data, 'rotDetails', rotDetails['ROTDetails']['CMRForm']); }
        } catch (e) { console.log(e); }

        //-------- Getting Job Details
        try {
          this.loadText = 'Getting Job Details'; 
          var rotJobDetails = await this.$apiCallV2('/ROT/ValidateJobsForROT?jobno=' + this.data['rotDetails']['Job No']);
          // console.log('%cJob Details', 'color: red;', rotJobDetails['data']);
          if (Array.isArray(rotJobDetails)) { this.$set(this.data['rotDetails'], 'Job_Type', rotJobDetails[0]['Job_Type']); } 
        } catch (e) { console.log(e); }
      } // Use for Edit/View Details
      this.mountData();

      //-------- Haul Bill To
      try {
        this.loadText = 'Getting Haul Bill To'; 
        var billCustCode = this.data['rotDetails']['CMR Bill To'] ? this.data['rotDetails']['CMR Bill To'] : (this.data['rotDetails']['billcu_no'] ? this.data['rotDetails']['billcu_no'] : '');
        var rotHaulBillTo = await this.$apiCallV2('/ROT/GetROTHaulBillTo?customercode=' + this.data['CustCode'] + '&billcust=' + billCustCode);
        // console.log(rotHaulBillTo);
        var rotHaulBillToF = [];
        if (typeof rotHaulBillTo == 'object') { rotHaulBillTo['BillToLists']['BillToList'].forEach((hb) => { rotHaulBillToF.push(hb); }); }
        this.$set(this.data, 'rotHaulBillTo', rotHaulBillToF);
        // this.$set(this.rotPersistentData, 'rotHaulBillToRaw', rotHaulBillTo['data']);
      } catch (e) { console.log(e); }
      
      
      //-------- SendTo
      try {
        this.$set(this.data, 'rotSendto', []); 
        // this.$set(this.data, 'rotSendtoRaw', []);

        this.loadText = 'Getting Send To Destinations'; 
        var rotSendto = await this.$apiCallV2('/ROT/GetListMaster?master=sendto&custNo=' + this.data['CustCode']);
        // console.log('%cSend To data', 'color: hotpink;');
        // console.log(rotSendto);
        var rotSendtoF = [];
        if (Array.isArray(rotSendto)) { rotSendto.forEach((s) => { rotSendtoF.push(s); }); }
        this.$set(this.data, 'rotSendto', rotSendtoF);
        // this.$set(this.data, 'rotSendtoRaw', rotSendto['data']);
      } catch (e) { console.log(e); }
      
      //-------- Cont Delivery Type
      try {
        this.$set(this.data, 'rotContROT', []);
        this.$set(this.data, 'rotContROTView', []);

        this.loadText = 'Getting Containers'; 
        var rotContROT = await this.$apiCallV2('/ROT/GetRotCont?jobno=' + this.data['JobNo'] + '&showall=1');
        // console.log('%cContainer Details', 'color: red;', rotContROT);
        var rotContROTF = [];
        if (Array.isArray(rotContROT)) { rotContROT.forEach((c) => { rotContROTF.push(c); }); }
        this.$set(this.data, 'rotContROT', rotContROTF);

        
        // Test
        switch(this.data['mode']) {
          case 'E' || 'V' || 'D':
            if (this.data['rotDetails']['ContDetail']) {
              var contData = Array.isArray(this.data['rotDetails']['ContDetail']) ? this.data['rotDetails']['ContDetail'] : [this.data['rotDetails']['ContDetail']];
              // console.log('%cContainer Filter', 'color: red;', contData);
              this.$set(this.data, 'rotContROTDetails', contData);

              this.data['rotContROTDetails'].forEach((c) => {
                var contItem = this.data['rotContROT'].filter((c2) => { return c2['Container #'].trim() == c['Cont No'].trim(); })
                var contIndex = this.data['rotContROT'].indexOf(contItem[0]);
                this.data['rotContROTView'].push(this.data['rotContROT'].splice(contIndex, 1)[0]);
              });
            }
          break;
        }
        // var rotContROTTest = await this.$apiCallV2('/ROT/GetRotCont?jobno=' + this.data['JobNo'] + '&showall=1');
        // console.log('%cTest Data Cotainers', 'color:cyan;');
        // console.log(rotContROTTest);

      } catch (e) { console.log(e); }
      

      this.mountSelectableData();
      this.loadShow = false;
      this.loadText = ''; 
    },
    mountData: async function() {
      // console.log('%cSelected ROT Data', 'color:lightgreen;', this.data['rotSelect']);
      // console.log('%cSelected ROT Data', 'color:lightgreen;', this.data['rotDetails']);
      try {
        try {
          //-------- Main Page
          this.$set(this.data, 'RotNo', this.data['rotDetails']['CMR No'] ? this.data['rotDetails']['CMR No'] : '');
          this.$set(this.data, 'JobNo', this.data['rotDetails']['Job No'] ? this.data['rotDetails']['Job No'] : (this.data['rotDetails']['Job_no'] ? this.data['rotDetails']['Job_no'] : ''));
          this.$set(this.data, 'JobType', this.data['rotDetails']['Job_Type'] ? this.data['rotDetails']['Job_Type'] : '');
          // this.$set(this.data, 'ROTDate', this.data['rotDetails']['CMR Time'] ? new Date(this.data['rotDetails']['CMR Time']) : (this.data['rotDetails']['Job_Date'] ? new Date(this.formatDatetoString(this.data['rotDetails']['Job_Date'])) : new Date));
          this.$set(this.data, 'ROTDate', this.data['rotDetails']['CMR Time'] ? new Date(this.data['rotDetails']['CMR Time']) : new Date);
          this.$set(this.data, 'Urgent', this.data['rotDetails']['Urgency'] ? (this.data['rotDetails']['Urgency'] == '1' ? true : false) : (this.data['rotDetails']['urgent'] == 'Y' ? true : false));
          this.$set(this.data, 'CustCode', this.data['rotDetails']['Cu Number'] ? this.data['rotDetails']['Cu Number'] : (this.data['rotDetails']['cu_number'] ? this.data['rotDetails']['cu_number'] : ''));
          this.$set(this.data, 'CustName', this.data['rotDetails']['Cu Name'] ? this.data['rotDetails']['Cu Name'] : (this.data['rotDetails']['cu_name'] ? this.data['rotDetails']['cu_name'] : ''));
          this.$set(this.data, 'HaulRqtNo', this.data['rotDetails']['Hau Request No'] ? this.data['rotDetails']['Hau Request No'] : '');
          this.$set(this.data, 'HaulAcceptTime', this.data['rotDetails']['Haul Accept Time'] ? this.data['rotDetails']['Haul Accept Time'] : '');
          this.$set(this.data, 'RqtAcceptBy', this.data['rotDetails']['Hau Accepted By'] ? this.data['rotDetails']['Hau Accepted By'] : '');
          this.$set(this.data, 'PrintCount', this.data['rotDetails']['Print Count'] ? this.data['rotDetails']['Print Count'] : '0');
          
          
          //-------- Location Page
          this.$set(this.data, 'Required', this.data['rotDetails']['Time Required From'] ? new Date(this.data['rotDetails']['Time Required From']) : new Date);
          this.$set(this.data, 'To', this.data['rotDetails']['Time Required To'] ? new Date(this.data['rotDetails']['Time Required To']) : new Date);
          this.$set(this.data, 'ShowAll', false);
          this.$set(this.data, 'Desc', this.data['rotDetails']['Req Time Description'] ? this.data['rotDetails']['Req Time Description'] : '');
          this.$set(this.data, 'OfficeHours', this.data['rotDetails']['Office Hours'] ? (this.data['rotDetails']['Office Hours'] == '1' ? true : false) : false);
          this.$set(this.data, 'AbilityNoCont', this.data['rotDetails']['AA Cont No'] ?this.data['rotDetails']['AA Cont No'] : '');
          this.$set(this.data, 'TimeNeeded', this.data['rotDetails']['Time Needed'] ? this.data['rotDetails']['Time Needed'] : '');
          this.$set(this.data, 'Offload', this.data['rotDetails']['Offload At Premis'] ? (this.data['rotDetails']['Offload At Premis'] == '1' ? true : false) : false);
          
          this.$set(this.data, 'PostCode', '');
          this.$set(this.data, 'Zone', '');
          this.$set(this.data, 'Attention', '');
          this.$set(this.data, 'TelNo', '');
          this.$set(this.data, 'Address', this.data['rotDetails']['Address'] ? this.data['rotDetails']['Address'] : '');
          
          
          //-------- Container Page

          this.$set(this.data, 'NoContRequired', this.data['rotDetails']['Total Container'] ? this.data['rotDetails']['Total Container'] : '');
          this.$set(this.data, 'Temperature', this.data['rotDetails']['Temperature'] ? this.data['rotDetails']['Temperature'] : '');
          this.$set(this.data, 'M3', this.data['rotDetails']['M3'] ? this.data['rotDetails']['M3'] : '');
          this.$set(this.data, 'Weight', this.data['rotDetails']['Height'] ? this.data['rotDetails']['Height'] : '');
          this.$set(this.data, 'Height', this.data['rotDetails']['Weight'] ? this.data['rotDetails']['Weight'] : '');
          this.$set(this.data, 'Remarks', this.data['rotDetails']['Remarks'] ? this.data['rotDetails']['Remarks'] : '');

          this.$set(this.data, 'Fumigation', this.data['rotDetails']['Fumigation'] ? (this.data['rotDetails']['Fumigation'] == '1' ? true : false) : false);
          this.$set(this.data, 'ContOperator', this.data['rotDetails']['Container Operator'] ? this.data['rotDetails']['Container Operator'] : '');
          this.$set(this.data, 'ContLine', this.data['rotDetails']['Container Line'] ? this.data['rotDetails']['Container Line'] : '');
          this.$set(this.data, 'Commodity', this.data['rotDetails']['Commodity'] ? this.data['rotDetails']['Commodity'] : '');

          //-------- Attachments Page

          let ROTAttachments = [];
          if (this.rotPersistentData['rotDetails']['Doc']) {
            ROTAttachments = this.rotPersistentData['rotDetails']['Doc'].map((attachment) => {
              return {
                "File Name":attachment["File Name"],
                "Date Added":this.$dateTime.getDateTime(attachment["Doc Date"], 'yyyy-MM-dd'),
                "Remarks":attachment["Doc Remark"],
                "DocumentGUID":attachment["Document GUID"]
              };
            });
          }
          this.$set(this.rotPersistentData, 'ROTAttachments', ROTAttachments);
          this.$set(this.rotPersistentData, 'NewROTAttachments', []);
          this.$set(this.rotPersistentData, 'RemovedROTAttachments', []);

          console.log('rotjobspopup mountdata');
          console.log(this.rotPersistentData);

        } catch (e) { /*console.log(e);*/ }
        //-------- Haul Bill To
        try {
          this.loadText = 'Getting Haul Bill To'; 
          var billCustCode = this.data['rotDetails']['CMR Bill To'] ? this.data['rotDetails']['CMR Bill To'] : (this.data['rotDetails']['billcu_no'] ? this.data['rotDetails']['billcu_no'] : '');
          var rotHaulBillTo = await this.$apiCallV2('/ROT/GetROTHaulBillTo?customercode=' + this.data['CustCode'] + '&billcust=' + billCustCode);
          // console.log(rotHaulBillTo);
          var rotHaulBillToF = [];
          if (typeof rotHaulBillTo == 'object') { rotHaulBillTo['BillToLists']['BillToList'].forEach((hb) => { rotHaulBillToF.push(hb); }); }
          this.$set(this.data, 'rotHaulBillTo', rotHaulBillToF);
          // this.$set(this.rotPersistentData, 'rotHaulBillToRaw', rotHaulBillTo['data']);
        } catch (e) { console.log(e); }
        
        
        //-------- SendTo
        try {
          this.$set(this.data, 'rotSendto', []); 
          // this.$set(this.data, 'rotSendtoRaw', []);

          this.loadText = 'Getting Send To Destinations'; 
          var rotSendto = await this.$apiCallV2('/ROT/GetListMaster?master=sendto&custNo=' + this.data['CustCode']);
          // console.log('%cSend To data', 'color: hotpink;');
          // console.log(rotSendto);
          var rotSendtoF = [];
          if (Array.isArray(rotSendto)) { rotSendto.forEach((s) => { rotSendtoF.push(s); }); }
          this.$set(this.data, 'rotSendto', rotSendtoF);
          // this.$set(this.data, 'rotSendtoRaw', rotSendto['data']);
        } catch (e) { console.log(e); }
        
        //-------- Cont Delivery Type
        try {
          this.$set(this.data, 'rotContROT', []);
          this.$set(this.data, 'rotContROTView', []);

          this.loadText = 'Getting Containers'; 
          var rotContROT = await this.$apiCallV2('/ROT/GetRotCont?jobno=' + this.data['JobNo'] + '&showall=1');
          // console.log('%cContainer Details', 'color: red;', rotContROT);
          var rotContROTF = [];
          if (Array.isArray(rotContROT)) { rotContROT.forEach((c) => { rotContROTF.push(c); }); }
          this.$set(this.data, 'rotContROT', rotContROTF);

          
          // Test
          switch(this.data['mode']) {
            case 'E' || 'V' || 'D':
              if (this.data['rotDetails']['ContDetail']) {
                var contData = Array.isArray(this.data['rotDetails']['ContDetail']) ? this.data['rotDetails']['ContDetail'] : [this.data['rotDetails']['ContDetail']];
                // console.log('%cContainer Filter', 'color: red;', contData);
                this.$set(this.data, 'rotContROTDetails', contData);

                this.data['rotContROTDetails'].forEach((c) => {
                  var contItem = this.data['rotContROT'].filter((c2) => { return c2['Container #'].trim() == c['Cont No'].trim(); })
                  var contIndex = this.data['rotContROT'].indexOf(contItem[0]);
                  this.data['rotContROTView'].push(this.data['rotContROT'].splice(contIndex, 1)[0]);
                });
              }
            break;
          }
          // var rotContROTTest = await this.$apiCallV2('/ROT/GetRotCont?jobno=' + this.data['JobNo'] + '&showall=1', JSON.parse(localStorage.getItem('loginDetails')));
          // console.log('%cTest Data Cotainers', 'color:cyan;');
          // console.log(rotContROTTest);

        } catch (e) { console.log(e); }
        

        this.mountSelectableData();
        this.loadShow = false;
        this.loadText = ''; 
      }
      catch (e) { /*console.log(e);*/ }
    },
    mountSelectableData: async function() {
      //-------- Main Page
      var itemSearch = this.data['rotHaulBillTo'].filter((s) => { if (this.data['rotDetails']['billcu_no'] || this.data['rotDetails']['CMR Bill To']) {
        return s['BillTo'].trim() == (this.data['mode'] == 'N' ? this.data['rotDetails']['billcu_no'].trim() : this.data['rotDetails']['CMR Bill To'].trim());
      }}); this.$set(this.data, 'HallBillTo', !(itemSearch.length > 0) ? null : itemSearch[0]);
      var itemSearch = this.data['rotHaulier'].filter((s) => { if (this.data['rotDetails']['Haulier Code']) { return s['Haulier Code'].trim() == this.data['rotDetails']['Haulier Code'].trim() }})
      this.$set(this.data, 'Haulier', !(itemSearch.length > 0) ? null : itemSearch[0]);
      var itemSearch = this.data['rotEmployee'].filter((s) => { if (this.data['rotDetails']['Requested By']) {
        return s['Employee ID'].trim() == (this.data['mode'] == 'N' ? this.data['rotDetails']['RequestedBy'].trim() : this.data['rotDetails']['Requested By'].trim());
      }});

      this.$set(this.data, 'RqtBy', !(itemSearch.length > 0) ? null : itemSearch[0]);
      this.$set(this.data, 'RotNo', this.data['rotDetails']['CMR No'] ? this.data['rotDetails']['CMR No'] : '');
      this.$set(this.data, 'JobNo', this.data['rotDetails']['Job No'] ? this.data['rotDetails']['Job No'] : (this.data['rotDetails']['Job_no'] ? this.data['rotDetails']['Job_no'] : ''));
      this.$set(this.data, 'JobType', this.data['rotDetails']['Job_Type'] ? this.data['rotDetails']['Job_Type'] : '');
      // this.$set(this.data, 'ROTDate', this.data['rotDetails']['CMR Time'] ? new Date(this.data['rotDetails']['CMR Time']) : (this.data['rotDetails']['Job_Date'] ? new Date(this.formatDatetoString(this.data['rotDetails']['Job_Date'])) : new Date));
      this.$set(this.data, 'ROTDate', this.data['rotDetails']['CMR Time'] ? new Date(this.data['rotDetails']['CMR Time']) : new Date);
      this.$set(this.data, 'Urgent', this.data['rotDetails']['Urgency'] ? (this.data['rotDetails']['Urgency'] == '1' ? true : false) : (this.data['rotDetails']['urgent'] == 'Y' ? true : false));
      this.$set(this.data, 'CustCode', this.data['rotDetails']['Cu Number'] ? this.data['rotDetails']['Cu Number'] : (this.data['rotDetails']['cu_number'] ? this.data['rotDetails']['cu_number'] : ''));
      this.$set(this.data, 'CustName', this.data['rotDetails']['Cu Name'] ? this.data['rotDetails']['Cu Name'] : (this.data['rotDetails']['cu_name'] ? this.data['rotDetails']['cu_name'] : ''));
      this.$set(this.data, 'HaulRqtNo', this.data['rotDetails']['Hau Request No'] ? this.data['rotDetails']['Hau Request No'] : '');
      this.$set(this.data, 'HaulAcceptTime', this.data['rotDetails']['Haul Accept Time'] ? this.data['rotDetails']['Haul Accept Time'] : '');
      this.$set(this.data, 'RqtAcceptBy', this.data['rotDetails']['Hau Accepted By'] ? this.data['rotDetails']['Hau Accepted By'] : '');
      this.$set(this.data, 'PrintCount', this.data['rotDetails']['Print Count'] ? this.data['rotDetails']['Print Count'] : '0');

      
      //-------- Location Page
      var itemSearch = this.data['rotPickup'].filter((s) => { if (this.data['rotDetails']['Pick Up']) { return s['Destination Code'].trim() == this.data['rotDetails']['Pick Up'].trim() }})
      this.$set(this.data, 'PickUp', !(itemSearch.length > 0) ? null : itemSearch[0]);
      var itemSearch = this.data['rotDropoff'].filter((s) => { if (this.data['rotDetails']['Drop Off']) { return s['Destination Code'].trim() == this.data['rotDetails']['Drop Off'].trim() }})
      this.$set(this.data, 'Dropoff', !(itemSearch.length > 0) ? null : itemSearch[0]);
      var itemSearch = this.data['rotTrips'].filter((s) => { if (this.data['rotDetails']['Trip']) { return s['Trip'].trim() == this.data['rotDetails']['Trip'].trim() }})
      this.$set(this.data, 'Trip', !(itemSearch.length > 0) ? null : itemSearch[0]);
      var itemSearch = this.data['rotSendto'].filter((s) => { if (this.data['rotDetails']['Destination Code']) { return s['Destination Code'].trim() == this.data['rotDetails']['Destination Code'].trim() }})
      this.$set(this.data, 'SendTo', !(itemSearch.length > 0) ? null : itemSearch[0]);
      this.$set(this.data, 'TariffArea', null);

      this.$set(this.data, 'Required', this.data['rotDetails']['Time Required From'] ? new Date(this.data['rotDetails']['Time Required From']) : new Date);
      this.$set(this.data, 'To', this.data['rotDetails']['Time Required To'] ? new Date(this.data['rotDetails']['Time Required To']) : new Date);
      this.$set(this.data, 'ShowAll', false);
      this.$set(this.data, 'Desc', this.data['rotDetails']['Req Time Description'] ? this.data['rotDetails']['Req Time Description'] : '');
      this.$set(this.data, 'OfficeHours', this.data['rotDetails']['Office Hours'] ? (this.data['rotDetails']['Office Hours'] == '1' ? true : false) : false);
      this.$set(this.data, 'AbilityNoCont', this.data['rotDetails']['AA Cont No'] ?this.data['rotDetails']['AA Cont No'] : '');
      this.$set(this.data, 'TimeNeeded', this.data['rotDetails']['Time Needed'] ? this.data['rotDetails']['Time Needed'] : '');
      this.$set(this.data, 'Offload', this.data['rotDetails']['Offload At Premis'] ? (this.data['rotDetails']['Offload At Premis'] == '1' ? true : false) : false);
      
      this.$set(this.data, 'PostCode', '');
      this.$set(this.data, 'Zone', '');
      this.$set(this.data, 'Attention', '');
      this.$set(this.data, 'TelNo', '');
      this.$set(this.data, 'Address', this.data['rotDetails']['Address'] ? this.data['rotDetails']['Address'] : '');
      
      
      //-------- Container Page
      var itemSearch = this.data['rotContSize'].filter((s) => { if (this.data['rotDetails']['Container Size']) { return s['Size'] == this.data['rotDetails']['Container Size'] }})
      this.$set(this.data, 'ContSize', !(itemSearch.length > 0) ? null : itemSearch[0]);
      var itemSearch = this.data['rotContType'].filter((s) => { if (this.data['rotDetails']['Container Type']) { return s['Cont Type'].trim() == this.data['rotDetails']['Container Type'].trim() }})
      this.$set(this.data, 'ContType', !(itemSearch.length > 0) ? null : itemSearch[0]);
      var itemSearch = this.data['rotContHdg'].filter((s) => { if (this.data['rotDetails']['Handling Type']) { return s['Handling Type'].trim() == this.data['rotDetails']['Handling Type'].trim() }})
      this.$set(this.data, 'Handling', !(itemSearch.length > 0) ? null : itemSearch[0]);
      var itemSearch = this.data['rotContDel'].filter((s) => { if (this.data['rotDetails']['Delivery Type']) { return s['Delivery Type'].trim() == this.data['rotDetails']['Delivery Type'].trim() }})
      this.$set(this.data, 'Delivery', !(itemSearch.length > 0) ? null : itemSearch[0]);

      this.$set(this.data, 'NoContRequired', this.data['rotDetails']['Total Container'] ? this.data['rotDetails']['Total Container'] : '');
      this.$set(this.data, 'Temperature', this.data['rotDetails']['Temperature'] ? this.data['rotDetails']['Temperature'] : '');
      this.$set(this.data, 'M3', this.data['rotDetails']['M3'] ? this.data['rotDetails']['M3'] : '');
      this.$set(this.data, 'Weight', this.data['rotDetails']['Height'] ? this.data['rotDetails']['Height'] : '');
      this.$set(this.data, 'Height', this.data['rotDetails']['Weight'] ? this.data['rotDetails']['Weight'] : '');
      this.$set(this.data, 'Remarks', this.data['rotDetails']['Remarks'] ? this.data['rotDetails']['Remarks'] : '');

      this.$set(this.data, 'Fumigation', this.data['rotDetails']['Fumigation'] ? (this.data['rotDetails']['Fumigation'] == '1' ? true : false) : false);
      this.$set(this.data, 'ContOperator', this.data['rotDetails']['Container Operator'] ? this.data['rotDetails']['Container Operator'] : '');
      this.$set(this.data, 'ContLine', this.data['rotDetails']['Container Line'] ? this.data['rotDetails']['Container Line'] : '');
      this.$set(this.data, 'Commodity', this.data['rotDetails']['Commodity'] ? this.data['rotDetails']['Commodity'] : '');
    },

    quickPrintBtn: async function(btn, cmd) {
      switch(btn) {
        case 'quickPrintShow':
          switch(this.data['Ind']) {
            case 'C':
              // var response = await this.$alert.questionAlert('Print Error', this.data['rotDetails']['CMR No'].trim() + ' has already been canceled.', 'Confirm', 'Cancel', 'error');
              var response = await this.$showAlert(
                  'error',
                  'Print Error', 
                  this.data['rotDetails']['CMR No'].trim() + 'has already been canceled.', 
                  [{"text" : "Confirm"},{"text" : "Cancel"}]
                  );

              if (response === "Confirm") {  }
              break;
            default: 
              this.$bus.$emit('ROTQuickPrintShow', cmd);
              break;
          }
          break;
      }
    },

    //-------- Utility Methods
    formatDatetoString: function (date) {
      if (typeof date == 'string') {
        //console.log(date);
        var dateF = date.replace(/\/Date\(/g, '').replace(/\)\//g, '').replace(/\-/g, '-');
        try {
          var dateFF = new Date(dateF);
          if (!(dateFF.getTime() === dateFF.getTime())) { dateFF = new Date(parseInt(dateF)); }
        } catch (e) { /*console.log(e);*/ }
      } else {
        var dateFF = date;
      }
      
      var d = ((dateFF.getDate().toString().length < 2) ? '0' : '') + dateFF.getDate().toString();
      var m = (((dateFF.getMonth() + 1).toString().length < 2) ? '0' : '') + (dateFF.getMonth() + 1).toString();
      var y = dateFF.getFullYear();
      var hh = ((dateFF.getHours().toString().length < 2) ? '0' : '') + dateFF.getHours().toString();
      var mm = ((dateFF.getMinutes().toString().length < 2) ? '0' : '') + dateFF.getMinutes().toString();

      return `${y}-${m}-${d} ${hh}:${mm}`;
    },
    formatStringtoDate: function (date) {
      var dateF = date.replace(/ /g, '/').replace(/\:/g, '/');
      var dateFF = dateF.split('/');
      return new Date(dateFF[0], (parseInt(dateFF[1]) - 1).toString(), dateFF[2], dateFF[3], dateFF[4]);
    },
  },
  watch: {
    
  },
}
</script>

<style lang="scss" scoped>
@import '@/css/all.scss';

  .popUpMain {
    width: 100%;
    height: 100%;
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
  }

  .popUpTop {
    width: 100%;
    height: auto;
    padding: 4px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .popUpCol {
    width: auto;
    height: 100%;
    margin: 0 20px 0 0;
    flex: 1;
  }

  .popUpTopCtrlMain {
    width: 60px;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
  }

  .indMain {
    width: 100%;
    height: 30px;
    font-size: 20px;
    font-weight: bold;
    display: flex;
    align-items: center;
    justify-content: center;
    border: solid 1px lightgray;
    border-radius: 4px;
  }

  .popUpTopCtrl {
    width: 100%;
    height: auto;
    padding: 4px 2px;
    margin: 0 0 4px 0;
    font-size: 12px;
    line-height: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .printCMain {
    width: 100%;
    height: auto;
    padding: 4px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    border: solid 1px lightgray;
    border-radius: 4px;
    cursor: pointer;
  }

  .printCImg {
    width: auto;
    height: 100%;
    user-select: none;
  }

  .printCValue {
    width: 100%;
    height: auto;
    margin: 4px 0 0 0;
    font-size: 12px;
    line-height: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    user-select: none;
  }

  .popUpBottom {
    width: 100%;
    height: 100%;
    padding: 0 4px;
    display: flex;
    align-items: flex-start;
    justify-content: center;
  }

  .tabsMain {
    width: 100%;
    height: auto;
    font-size: 12px;
  }

  .rowItems {
    width: 100%;
    height: auto;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .rowItems * {
    width: 49%;
  }

</style>

